export default "__VITE_ASSET__CRoGfpJ5__"